import React from "react";
import Engage from "../components/pages/Engage/Engage";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const EngageLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <Engage />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default EngageLayout;
